export default __webpack_public_path__ + "static/profile-picture-3-b701fcb37cb1fef6a7e720dccd16e4c0.jpg";